import React from 'react';
import { fetchConnector, FetchPNLAnalyticsPropsFromRedux } from '../dataFetcher';
import { P_FEI, P_LST, P_ARA, P_CP } from '../../common/products';
import { SimpleTableColumnConfig, SimpleTableConfig, TableSize } from '../../tables/types';
import { exposuresNumFormatter, spreadPriceFormatter } from '../../common/exposures';
import { UniqueTableName } from '../../common/uniqueTableName';
import { AggFuncName } from '../../common/cellRangeAgg';
import { PNLAnalyticsEndpoint, PNLFetchStatus } from '../../actions/pnlAnalytics';
import { PNLGoodiesNonCompletedResponses } from '../PaperPlaceHolder';
import { BackOfficeMiscDataResp } from '../fetchTypes';
import SimpleTable from '../../tables/SimpleTable';

type Props = FetchPNLAnalyticsPropsFromRedux & {};

const pivotColumns: Array<SimpleTableColumnConfig> = [
    {
        name: 'spread',
        title: 'Spread',
    },
];

const productColumns = [P_FEI, P_LST, P_ARA, P_CP];
const productsColumnConfig: Array<SimpleTableColumnConfig> = productColumns.map((productName) => {
    return {
        name: productName,
        title: productName,
        bodyTemplate: spreadPriceFormatter,
    };
});

const allColumns = pivotColumns.concat(productsColumnConfig);

const config: SimpleTableConfig = {
    uniqueTableName: UniqueTableName.CorpSpreadPrices,
    title: 'Spread Prices',
    size: TableSize.Small,
    columns: allColumns,
    grandTotal: false,
    aggFormatVal: (aggFuncName: AggFuncName, val: number) => {
        return aggFuncName === AggFuncName.Count ? val : exposuresNumFormatter(val);
    },
    pivotDepth: 0,
    stickyHeader: true,
};

const CorpSpreadPrices = (props: Props) => {
    const backOfficeMiscData = props.pnlAnalytics.back_office_misc;
    if (backOfficeMiscData.status !== PNLFetchStatus.COMPLETED) {
        return (
            <PNLGoodiesNonCompletedResponses endpoint={PNLAnalyticsEndpoint.BackOfficeMisc} data={backOfficeMiscData} minHeight={'462px'} />
        );
    }

    let respData = backOfficeMiscData.data! as BackOfficeMiscDataResp;

    return <SimpleTable data={respData.spread_prices} config={config} />;
};

export default fetchConnector(CorpSpreadPrices);
